export const environment = {
  production: true,
  title: 'Dev',

  baseUrl:"https://wa-aeu-sds-dev-saludmigrantes-back.azurewebsites.net/",

  baseUrlSeguridad:"https://wa-aeu-sds-dev-saludmigrantes-back.azurewebsites.net/api/v1/",


  recaptcha: {
    siteKey: '6LeQurkqAAAAAHqPJ1_WhmxKDSGFSQn4s43gn4Y7',
  },
  fecha: "2023-05-18"
};
